import React from 'react';
import { SITE_CONTENT } from '../content';

const InstagramSection = () => {
  const insta = SITE_CONTENT.pages?.homePage?.instagramSection || {};
  const subtitle = insta.subtitle || "Follow Us";
  const title = insta.title || "Taste the Experience";
  const handle = insta.handle || "@nawabicaterers";
  const url = insta.url || "https://instagram.com/nawabicaterers";
  const photos = insta.photos || [];

  return (
    <section className="bg-[#f0ebe0] py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        {/* ── Header ── */}
        <div className="text-center mb-12">
          <p className="text-[#4a7c59] text-[10px] tracking-[0.35em] uppercase font-semibold mb-3">
            {subtitle}
          </p>
          <h2 className="text-[#1a2e1a] text-3xl sm:text-4xl font-light mb-5">
            {title}
          </h2>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-6 py-2.5 bg-[#1a2e1a] text-white text-xs tracking-[0.18em] font-medium rounded-full hover:bg-[#2d4a2d] transition-all duration-300 hover:scale-105 shadow-md"
          >
            {handle}
          </a>
        </div>

        {/* ── 3×2 Photo Grid ── */}
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 lg:gap-4">
          {photos.map((photo, i) => (
            <a
              key={i}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative overflow-hidden rounded-sm block"
            >
              <img
                src={photo.src}
                alt={photo.alt}
                className="w-full h-[200px] sm:h-[220px] lg:h-[260px] object-cover object-center group-hover:scale-105 transition-transform duration-600"
              />

              {/* Hover overlay with Instagram icon */}
              <div className="absolute inset-0 bg-[#1a2e1a]/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                {/* Instagram SVG icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="w-8 h-8 drop-shadow-lg"
                >
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                  <circle cx="12" cy="12" r="4" />
                  <circle cx="17.5" cy="6.5" r="0.5" fill="white" stroke="none" />
                </svg>
              </div>
            </a>
          ))}
        </div>

      </div>
    </section>
  );
};

export default InstagramSection;
